import { render, staticRenderFns } from "./AdminQa.vue?vue&type=template&id=885ab16a&"
import script from "./AdminQa.vue?vue&type=script&lang=js&"
export * from "./AdminQa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports